module.exports = "/images/paysafecard.jpg?f0f7a9ff74a53e1c8e891d3a1ed0db16";